import jszip from "jszip";
import { saveAs } from "file-saver";

/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, " ") +
      '"}'
  );
}

/**
 *
 * @param arr
 * @param u_key
 */
export function arrayUniqueByPropperty(arr, name) {
  let hash = {};

  return arr.reduce(function (item, next) {
    if (!hash[next[name]]) {
      hash[next[name]] = true;
      item.push(next);
    }
    return item;
  }, []);
}

export function myAsync(fun) {
  return new Promise((resolve) => fun(resolve));
}

/**
 * 获取浏览器query参数值
 * @param name
 * @returns {*}
 */
export const getQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
};

export const downloadZip = (base64Datas) => {
  var zip = new jszip();
  base64Datas.forEach((item) => {
    //console.log(item.data)
    zip.file(item.name + ".png", item.data);
  });
  zip.generateAsync({ type: "blob" }).then(function (content) {
    saveAs(content, "图表.zip");
  });
};

/**
 * 比较两个对象各属性的值
 * @param obj1
 * @param obj2
 * @returns {boolean}
 */
export const comparisonValue = (obj1, obj2) => {
  for (let key in obj1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
};

export const findmax = (data, key, ratio) => {
  if (!data || data.length === 0) return null;
  return data.reduce((prev, next) => {
    let _prev = { ...prev },
      _next = { ...next };
    if (ratio) {
      _prev[key] = _prev[key] / ratio;
      _next[key] = _next[key] / ratio;
    }
    return _prev[key] > _next[key] ? prev : next;
  });
};
export const findmin = (data, key, ratio) => {
  if (!data || data.length === 0) return null;
  return data.reduce((prev, next) => {
    let _prev = { ...prev },
      _next = { ...next };
    if (ratio) {
      _prev[key] = _prev[key] / ratio;
      _next[key] = _next[key] / ratio;
    }
    return _prev[key] > _next[key] ? next : prev;
  });
};

function dataURItoBlob(dataURI) {
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0]; // mime类型
  var byteString = atob(dataURI.split(",")[1]); //base64 解码
  var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
  var intArray = new Uint8Array(arrayBuffer); //创建视图

  for (var i = 0; i < byteString.length; i++) {
    intArray[i] = byteString.charCodeAt(i);
  }
  return new Blob([intArray], { type: mimeString });
}

export const downBase64File = (data, name) => {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(dataURItoBlob(data), name);
  } else {
    let a = document.createElement("a");
    a.href = data;
    a.download = name;
    a.click();
  }
};

export const debounce = function (fn, delay) {
  var timer;
  return function () {
    var ctx = this;
    var args = arguments;

    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(ctx, args);
    }, delay);
  };
};
